import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileService } from '../profile/profile.service';


@Injectable({
  providedIn: 'root'
})
export class PublicRedirectGuardService {

  constructor(
    private _profile: ProfileService,
    private _router: Router,
    private ActivatedRoute: ActivatedRoute,
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let webSocketVal = false;
    let webSocketCode = '';
    let webSocketId = '';

    this.ActivatedRoute.queryParams.subscribe(params => {
      const data = params['requestLogin'];
      if (data == 'true') {
        this._router.navigate(['/login'], { queryParams: { returnUrl: state.url.replace('?requestLogin=true', '') } });
      }
    });
    if (this._profile.getToken()) {
      const url = state.url.split('/');
      url.forEach(element => {
        if (element.includes('webSocketOperation')) {
          webSocketVal = true;
          webSocketCode = element;
          webSocketId = webSocketCode.split('=')[1];
        }
      });
      if (webSocketVal) {
        this._router.navigate(['u', url[1], url[2], 'webSocketOperation'], { queryParams: { id: webSocketId } });
      }
      else {
        // Limpiar requestLogin de url[2] si existe
        if (url[2]) {
          url[2] = url[2].replace(/[?&]requestLogin=true/g, '');
        }
        this._router.navigate(['u', url[1], url[2]]);
      }
      return false;
    }
    document.body.classList.add('is-public');

    return true;
  }
}
